import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox } from "vue"
import _imports_0 from '@/assets/filter.svg'
import _imports_1 from '@/assets/filterIcon_Disabled.svg'
import _imports_2 from '@/assets/cancel.svg'
import _imports_3 from '@/assets/pdf.svg'
import _imports_4 from '@/assets/doc.svg'
import _imports_5 from '@/assets/docx.svg'
import _imports_6 from '@/assets/xls.svg'
import _imports_7 from '@/assets/xlsx.svg'
import _imports_8 from '@/assets/txt.svg'
import _imports_9 from '@/assets/png.svg'
import _imports_10 from '@/assets/jpg.svg'
import _imports_11 from '@/assets/jpeg.svg'
import _imports_12 from '@/assets/csv.svg'
import _imports_13 from '@/assets/zip.svg'
import _imports_14 from '@/assets/mp4.svg'
import _imports_15 from '@/assets/link.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "items-center justify-between flex ResponsivestartPresentAudit" }
const _hoisted_3 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "flex items-center gap-3" }
const _hoisted_6 = {
  key: 0,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_7 = {
  key: 1,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_8 = { class: "mainContainer tabStructure w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_9 = { class: "h-full" }
const _hoisted_10 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle heightFixing"
}
const _hoisted_11 = { class: "lg:flex" }
const _hoisted_12 = { class: "lg:w-1/2" }
const _hoisted_13 = {
  key: 0,
  class: "w-full h-full flex justify-center items-center"
}
const _hoisted_14 = { id: "chart" }
const _hoisted_15 = {
  key: 1,
  class: "w-full h-full flex justify-center items-center text-xs"
}
const _hoisted_16 = { class: "lg:w-1/2 topPaddingForTable" }
const _hoisted_17 = { class: "tableCornerRadius w-90" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 1,
  class: "flex"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { class: "table-ellipsis" }
const _hoisted_23 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle mt-3 cardHeightFixing"
}
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "row flex flex-row w-full" }
const _hoisted_26 = { class: "w-1/2 pr-2" }
const _hoisted_27 = { class: "row flex flex-row w-full mt-2 text-sm" }
const _hoisted_28 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_29 = { class: "w-1/2 pr-2" }
const _hoisted_30 = { class: "text-sm mt-2" }
const _hoisted_31 = { class: "w-1/2 pr-2" }
const _hoisted_32 = { class: "text-sm mt-2" }
const _hoisted_33 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_34 = { class: "w-1/2 pr-2" }
const _hoisted_35 = { class: "text-sm mt-2" }
const _hoisted_36 = { class: "w-1/2 pr-2" }
const _hoisted_37 = { class: "text-sm mt-2" }
const _hoisted_38 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_39 = { class: "w-1/2 pr-2" }
const _hoisted_40 = { class: "text-sm mt-2" }
const _hoisted_41 = { class: "w-1/2 pr-2" }
const _hoisted_42 = { class: "text-sm flex flex-wrap" }
const _hoisted_43 = {
  key: 0,
  class: "pt-2"
}
const _hoisted_44 = { class: "w-auto h-6 bg-primary mr-3 px-2 rounded-sm flex items-center text-white text-sm" }
const _hoisted_45 = { class: "row flex flex-row w-full mb-5 mt-3" }
const _hoisted_46 = { class: "w-1/2 pr-2" }
const _hoisted_47 = { class: "text-sm flex flex-wrap pt-2" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = { class: "w-auto h-6 bg-primary mr-3 px-2 rounded-sm flex items-center text-white text-sm" }
const _hoisted_50 = { class: "w-1/2 pr-2" }
const _hoisted_51 = { class: "text-sm flex mt-2 flex-wrap" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "w-auto h-6 bg-primary mr-3 px-2 rounded-sm flex items-center text-white text-sm" }
const _hoisted_54 = {
  key: 2,
  class: "overflow-y-scroll descriptionToggle mt-3 cardHeight"
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle mt-3 cardHeight"
}
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { class: "flex items-center justify-between m-4 rounded" }
const _hoisted_59 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_60 = { class: "formcontainer flex flex-col" }
const _hoisted_61 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_62 = { class: "w-1/2 pr-2" }
const _hoisted_63 = { class: "text-sm mt-2" }
const _hoisted_64 = { class: "w-1/2 pr-2" }
const _hoisted_65 = { class: "text-sm mt-2" }
const _hoisted_66 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_67 = { class: "w-1/2 pr-2" }
const _hoisted_68 = { class: "text-sm mt-2" }
const _hoisted_69 = { class: "w-1/2 pr-2" }
const _hoisted_70 = { class: "w-full mt-3" }
const _hoisted_71 = { class: "text-sm mt-2" }
const _hoisted_72 = { class: "w-full mt-3" }
const _hoisted_73 = { class: "text-sm mt-2" }
const _hoisted_74 = {
  key: 0,
  class: "flex gap-3 flex-wrap"
}
const _hoisted_75 = { class: "pdf w-full rounded-sm" }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = {
  key: 0,
  src: _imports_3,
  alt: ""
}
const _hoisted_78 = {
  key: 1,
  src: _imports_4,
  alt: ""
}
const _hoisted_79 = {
  key: 2,
  src: _imports_5,
  alt: ""
}
const _hoisted_80 = {
  key: 3,
  src: _imports_6,
  alt: ""
}
const _hoisted_81 = {
  key: 4,
  src: _imports_7,
  alt: ""
}
const _hoisted_82 = {
  key: 5,
  src: _imports_8,
  alt: ""
}
const _hoisted_83 = {
  key: 6,
  src: _imports_9,
  alt: ""
}
const _hoisted_84 = {
  key: 7,
  src: _imports_10,
  alt: ""
}
const _hoisted_85 = {
  key: 8,
  src: _imports_11,
  alt: ""
}
const _hoisted_86 = {
  key: 9,
  src: _imports_12,
  alt: ""
}
const _hoisted_87 = {
  key: 10,
  src: _imports_13,
  alt: ""
}
const _hoisted_88 = {
  key: 11,
  src: _imports_14,
  alt: ""
}
const _hoisted_89 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_90 = { class: "ml-2 pb-1" }
const _hoisted_91 = ["title"]
const _hoisted_92 = { class: "flex justify-between w-full" }
const _hoisted_93 = { class: "ml-2 fontSize10PX" }
const _hoisted_94 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_95 = { class: "pdf w-full rounded-sm" }
const _hoisted_96 = ["onClick", "aria-label"]
const _hoisted_97 = { class: "finding-evidence-link-icon__img-wrap" }
const _hoisted_98 = { class: "finding-evidence-link-icon__tooltip" }
const _hoisted_99 = { class: "flex flex-col w-full min-w-0" }
const _hoisted_100 = { class: "ml-2 pb-1" }
const _hoisted_101 = ["title"]
const _hoisted_102 = { class: "flex justify-between w-full" }
const _hoisted_103 = { class: "ml-2 fontSize10PX" }
const _hoisted_104 = { class: "mr-2 fontSize10PX font-semibold" }
const _hoisted_105 = { key: 1 }
const _hoisted_106 = { class: "w-1/2 mt-3" }
const _hoisted_107 = { class: "mt-2" }
const _hoisted_108 = {
  key: 0,
  class: "flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor border-solid border border-lightgreen text-xs"
}
const _hoisted_109 = {
  key: 1,
  class: "flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor border-solid border border-darkred text-xs"
}
const _hoisted_110 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_111 = { class: "popup-business" }
const _hoisted_112 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_113 = { class: "formcontainer flex flex-col" }
const _hoisted_114 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_115 = { class: "w-full px-1" }
const _hoisted_116 = { class: "row flex flex-row w-full mt-3" }
const _hoisted_117 = { class: "w-full px-1 flex" }
const _hoisted_118 = { class: "formcontainer flex justify-center mt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_apexchart = _resolveComponent("apexchart")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["pt-3 pl-5 pr-5", { 'details-in-modal': _ctx.modalMode }])
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.presentAuditObject.title), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.selectedTabIndex == 3 )
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "filterButton flex",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpenForAuditInfo && _ctx.filterOpenForAuditInfo(...args)))
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("img", {
                src: _imports_0,
                class: "filterIcon"
              }, null, -1),
              _createTextVNode(" Filters ")
            ])))
          : _createCommentVNode("", true),
        (_ctx.selectedTabIndex == 4)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: _normalizeClass(["flex", _ctx.tableRow.length == 0 ? 'btndisabled pointer-events-none flex' : 'filterButton']),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpenForFindings && _ctx.filterOpenForFindings(...args)))
            }, [
              (_ctx.tableRow.length == 0)
                ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _cache[12] || (_cache[12] = _createTextVNode(" Filters "))
            ], 2))
          : _createCommentVNode("", true),
        (_ctx.presentAuditObject.statusCode == 10401 && _ctx.presentAuditObject && _ctx.presentAuditObject!=undefined && _ctx.presentAuditObject.teamLeader && _ctx.presentAuditObject.teamLeader!=undefined && (_ctx.presentAuditObject.teamLeader.value==_ctx.userInfo._id|| (this.userInfo.organisationType==10701)))
          ? (_openBlock(), _createElementBlock("button", {
              key: 2,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.startPresentAudit()))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["btnPrimaryPadding", !_ctx.isAddDisabled(10301)?'btndisabled pointer-events-none ':'btnprimary flex items-center btnPrimaryPadding'])
              }, "Start", 2)
            ]))
          : _createCommentVNode("", true),
        (_ctx.presentAuditObject.statusCode && _ctx.presentAuditObject.statusCode!= 10401)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.startPresentAudit()))
            }, _cache[13] || (_cache[13] = [
              _createElementVNode("div", { class: "btnPrimaryPadding btnprimary items-center" }, "Tasks", -1)
            ])))
          : _createCommentVNode("", true),
        (_ctx.presentAuditObject.statusCode != 10418 && _ctx.tasksOpen && _ctx.presentAuditObject.statusCode != 10401 && (_ctx.TeamLeaderValue == _ctx.userInfo._id || (_ctx.userInfo.organisationType==10701 &&_ctx.userInfo.role_id!=10216)|| (_ctx.userInfo.organisationType==10702 &&_ctx.userInfo.roleId!=10216)))
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onclickTerminate())),
              class: _normalizeClass([_ctx.tasksOpen == true ? 'btnprimary':'btndisabled', "items-center"])
            }, _cache[14] || (_cache[14] = [
              _createElementVNode("div", null, "Terminate", -1)
            ]), 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", null, [
        _createVNode(_component_Tabs, {
          value: _ctx.selectedTabIndex,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
          scrollable: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_TabList, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                    return (_openBlock(), _createBlock(_component_Tab, {
                      key: tab.id,
                      value: tab.id,
                      onClick: ($event: any) => (_ctx.toggleTabs(tab))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(tab.displayName), 1)
                      ]),
                      _: 2
                    }, 1032, ["value", "onClick"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab) => {
                  return (_openBlock(), _createBlock(_component_TabPanel, {
                    key: tab.id,
                    value: tab.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_9, [
                        (tab.id == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  (_ctx.series.length > 0 && _ctx.presentAuditObject.statusCode != 10401)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                        _createElementVNode("div", _hoisted_14, [
                                          _createVNode(_component_apexchart, {
                                            type: "pie",
                                            width: "380",
                                            options: _ctx.chartOptions,
                                            onDataPointSelection: _ctx.clickOnPieLabel,
                                            series: _ctx.series
                                          }, null, 8, ["options", "onDataPointSelection", "series"])
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString('Audit Not Started')))
                                ]),
                                _createElementVNode("div", _hoisted_16, [
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("table", null, [
                                      _createElementVNode("thead", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (column) => {
                                          return (_openBlock(), _createElementBlock("th", {
                                            scope: "col",
                                            key: column,
                                            class: _normalizeClass([_ctx.getColumnHeadWidth(column), "bg-white th1 cursor-pointer capitalize"])
                                          }, [
                                            (column == 'taskStatus')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[15] || (_cache[15] = [
                                                  _createElementVNode("div", null, _toDisplayString(''), -1)
                                                ])))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                  _createElementVNode("div", null, _toDisplayString(column), 1)
                                                ]))
                                          ], 2))
                                        }), 128))
                                      ]),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.viewAuditObj, (row, index) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: index,
                                            class: "rowHeight"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headers, (presentColumn) => {
                                              return (_openBlock(), _createElementBlock("td", {
                                                key: presentColumn,
                                                class: "cursor-pointer relative"
                                              }, [
                                                (presentColumn == 'status')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.textColor(row['taskStatus']))
                                                      }, _toDisplayString((_ctx.taskStatusCodes.find((l)=>{
                                                                                                return  l.id == row['taskStatus']
                                                                                            }) || {}).value || '-'), 3)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                      _createElementVNode("div", _hoisted_22, [
                                                        _createElementVNode("div", {
                                                          class: _normalizeClass(presentColumn == 'tasks'?'pl-3':'')
                                                        }, _toDisplayString(row[presentColumn]), 3)
                                                      ])
                                                    ]))
                                              ]))
                                            }), 128))
                                          ]))
                                        }), 128))
                                      ])
                                    ])
                                  ]),
                                  _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-xs flex items-center justify-center w-90 pt-2 mb-2" }, [
                                    _createElementVNode("p", { class: "font-semibold text-darkred" }, "*Note : "),
                                    _createTextVNode(" To close the Audit All Tasks should be in completed state.")
                                  ], -1))
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (tab.id == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                  _createElementVNode("div", _hoisted_26, [
                                    _cache[18] || (_cache[18] = _createElementVNode("label", { class: "controllabel" }, "Audit Period", -1)),
                                    _createElementVNode("div", _hoisted_27, [
                                      _createTextVNode(_toDisplayString(_ctx.changeDateFormat(_ctx.presentAuditObject?.period?.fromDate)) + " ", 1),
                                      _cache[17] || (_cache[17] = _createElementVNode("div", { class: "pl-1 pr-1 text-sm" }, "-", -1)),
                                      _createTextVNode(" " + _toDisplayString(_ctx.changeDateFormat(_ctx.presentAuditObject?.period?.toDate)), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel" }, "Audit Start Date", -1)),
                                    _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.changeDateFormat(_ctx.presentAuditObject.startDate) != undefined ? _ctx.changeDateFormat(_ctx.presentAuditObject.startDate) : 'N/A'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_31, [
                                    _cache[20] || (_cache[20] = _createElementVNode("label", { class: "controllabel" }, "Audit End Date", -1)),
                                    _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.changeDateFormat(_ctx.presentAuditObject.endDate) != undefined ? _ctx.changeDateFormat(_ctx.presentAuditObject.endDate) : 'N/A'), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_33, [
                                  _createElementVNode("div", _hoisted_34, [
                                    _cache[21] || (_cache[21] = _createElementVNode("label", { class: "controllabel" }, "Audit Title", -1)),
                                    _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.presentAuditObject.title != undefined ? _ctx.presentAuditObject.title : 'N/A'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_36, [
                                    _cache[22] || (_cache[22] = _createElementVNode("label", { class: "controllabel" }, "Audit Id", -1)),
                                    _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.presentAuditObject.auditId != undefined ? _ctx.presentAuditObject.auditId : 'N/A'), 1)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_38, [
                                  _createElementVNode("div", _hoisted_39, [
                                    _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel" }, "Team Leader", -1)),
                                    _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.presentAuditObject.teamLeader != undefined ? _ctx.presentAuditObject.teamLeader.label : 'N/A'), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_41, [
                                    _cache[24] || (_cache[24] = _createElementVNode("label", { class: "controllabel" }, "Frameworks (Maximum 3 Frameworks )", -1)),
                                    _createElementVNode("div", _hoisted_42, [
                                      (_ctx.presentAuditObject.frameworks == '' || _ctx.presentAuditObject.frameworks == [] || _ctx.presentAuditObject.frameworks == undefined || _ctx.presentAuditObject.frameworks == null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, "N/A"))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.presentAuditObject.frameworks, (framework) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              class: "pt-2 pb-2",
                                              key: framework
                                            }, [
                                              _createElementVNode("div", _hoisted_44, _toDisplayString(framework), 1)
                                            ]))
                                          }), 128))
                                    ])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _cache[25] || (_cache[25] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                                    _createElementVNode("div", _hoisted_47, [
                                      (_ctx.presentAuditObject.location == '' || _ctx.presentAuditObject.location == [] || _ctx.presentAuditObject.location == undefined || _ctx.presentAuditObject.location == null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, "N/A"))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.presentAuditObject.location, (location) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: location,
                                              class: "pb-2"
                                            }, [
                                              _createElementVNode("div", _hoisted_49, _toDisplayString(location), 1)
                                            ]))
                                          }), 128))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_50, [
                                    _cache[26] || (_cache[26] = _createElementVNode("label", { class: "controllabel" }, "Audit Members", -1)),
                                    _createElementVNode("div", _hoisted_51, [
                                      (_ctx.presentAuditObject.auditMembers == '' || _ctx.presentAuditObject.auditMembers == [] || _ctx.presentAuditObject.auditMembers == undefined || _ctx.presentAuditObject.auditMembers == null)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, "N/A"))
                                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.presentAuditObject.auditMembers, (member) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: member,
                                              class: "pb-2"
                                            }, [
                                              _createElementVNode("div", _hoisted_53, _toDisplayString(member), 1)
                                            ]))
                                          }), 128))
                                    ])
                                  ])
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (tab.id == 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                              _createElementVNode("div", null, [
                                _createVNode(_component_tableData, {
                                  tableRowData: _ctx.teamsArray,
                                  headersData: _ctx.Headers,
                                  loadData: _ctx.dataLoading
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          (tab.id == 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _createVNode(_component_tableData, {
                                  tableRowData: _ctx.tableRow,
                                  headersData: _ctx.mainHeaders,
                                  loadData: _ctx.dataLoading1
                                }, null, 8, ["tableRowData", "headersData", "loadData"]),
                                (_ctx.toolTipActive)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                                      _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    (_ctx.showPopUp && _ctx.selectedTabObj.id == 4)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 1,
          popUp: _ctx.showPopUp
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_58, [
              _cache[28] || (_cache[28] = _createElementVNode("h1", null, "Finding", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onCancelButtonAddPopUp()))
              }, _cache[27] || (_cache[27] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("fieldset", null, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("div", _hoisted_62, [
                      _cache[29] || (_cache[29] = _createElementVNode("label", { class: "controllabel" }, "Finding-Id", -1)),
                      _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.ActionObj.findingId), 1)
                    ]),
                    _createElementVNode("div", _hoisted_64, [
                      _cache[30] || (_cache[30] = _createElementVNode("label", { class: "controllabel" }, "Finding Category", -1)),
                      _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.findingCategoryData.find((category)=>{
                                        return category.id == _ctx.ActionObj.findingCategory
                                    }).value), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, [
                      _cache[31] || (_cache[31] = _createElementVNode("label", { class: "controllabel" }, "Framework", -1)),
                      _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.ActionObj.frameworks), 1)
                    ]),
                    _createElementVNode("div", _hoisted_69, [
                      _cache[32] || (_cache[32] = _createElementVNode("label", { class: "controllabel" }, "Control Number", -1)),
                      _createElementVNode("div", {
                        class: _normalizeClass([_ctx.getBorder(), "text-xs mt-2 px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center"])
                      }, _toDisplayString(_ctx.ActionObj.frameWorkControl), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_70, [
                    _cache[33] || (_cache[33] = _createElementVNode("label", { class: "controllabel" }, "Findings", -1)),
                    _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.ActionObj.findingComment), 1)
                  ]),
                  _createElementVNode("div", _hoisted_72, [
                    _cache[35] || (_cache[35] = _createElementVNode("label", { class: "controllabel" }, "Evidence", -1)),
                    _createElementVNode("div", _hoisted_73, [
                      (_ctx.actionFileEvidences.length || _ctx.actionLinkEvidences.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionFileEvidences, (doc, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'action-file-'+index
                              }, [
                                _createElementVNode("div", _hoisted_75, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                    class: "flex w-full flex-row items-center cursor-pointer"
                                  }, [
                                    (_ctx.getEvidenceFileExt(doc)=='pdf')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_77))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='doc')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_78))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='docx')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_79))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='xls')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_80))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='xlsx')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_81))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='txt')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_82))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='png')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_83))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='jpg')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_84))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='jpeg')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_85))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='csv')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_86))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='zip')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_87))
                                      : _createCommentVNode("", true),
                                    (_ctx.getEvidenceFileExt(doc)=='mp4')
                                      ? (_openBlock(), _createElementBlock("img", _hoisted_88))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_89, [
                                      _createElementVNode("div", _hoisted_90, [
                                        _createElementVNode("p", {
                                          class: "text-xs font-medium truncate",
                                          title: doc.filename || doc.name
                                        }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_91)
                                      ]),
                                      _createElementVNode("div", _hoisted_92, [
                                        _createElementVNode("p", _hoisted_93, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 1),
                                        _createElementVNode("p", _hoisted_94, _toDisplayString(doc.taskId ? doc.taskId : 'N/A'), 1)
                                      ])
                                    ])
                                  ], 8, _hoisted_76)
                                ])
                              ]))
                            }), 128)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actionLinkEvidences, (doc, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: 'action-link-'+index
                              }, [
                                _createElementVNode("div", _hoisted_95, [
                                  _createElementVNode("a", {
                                    href: "#",
                                    onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                    class: "flex w-full flex-row items-center cursor-pointer finding-evidence-link-icon",
                                    "aria-label": doc.url
                                  }, [
                                    _createElementVNode("span", _hoisted_97, [
                                      _cache[34] || (_cache[34] = _createElementVNode("img", {
                                        src: _imports_15,
                                        alt: "Link",
                                        class: "finding-evidence-link-icon__img"
                                      }, null, -1)),
                                      _createElementVNode("span", _hoisted_98, _toDisplayString(doc.url), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_99, [
                                      _createElementVNode("div", _hoisted_100, [
                                        _createElementVNode("p", {
                                          class: "text-xs font-medium truncate",
                                          title: doc.filename || doc.name
                                        }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_101)
                                      ]),
                                      _createElementVNode("div", _hoisted_102, [
                                        _createElementVNode("p", _hoisted_103, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 1),
                                        _createElementVNode("p", _hoisted_104, _toDisplayString(doc.taskId ? doc.taskId : 'N/A'), 1)
                                      ])
                                    ])
                                  ], 8, _hoisted_96)
                                ])
                              ]))
                            }), 128))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_105, _toDisplayString(Array.isArray(_ctx.ActionObj.findingEvidence) ? _ctx.ActionObj.findingEvidence.join(', ') : _ctx.ActionObj.findingEvidence), 1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_106, [
                    _cache[36] || (_cache[36] = _createElementVNode("label", { class: "controllabel" }, "Control Audit Result", -1)),
                    _createElementVNode("div", _hoisted_107, [
                      (_ctx.ActionObj.auditResult === 'Pass')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, _toDisplayString(_ctx.ActionObj.auditResult), 1))
                        : _createCommentVNode("", true),
                      (_ctx.ActionObj.auditResult === 'Fail')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_109, _toDisplayString(_ctx.ActionObj.auditResult), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showTerminatePopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.showTerminatePopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_110, [
              _createElementVNode("h1", null, "Terminate - " + _toDisplayString(_ctx.presentAuditObject.title), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onCancelTerminate()))
              }, _cache[37] || (_cache[37] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_111, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _createElementVNode("div", _hoisted_114, [
                        _createElementVNode("div", _hoisted_115, [
                          _cache[38] || (_cache[38] = _createElementVNode("label", {
                            for: "number",
                            class: "controllabel"
                          }, "Reason/Justification for Terminating the Audit", -1)),
                          _cache[39] || (_cache[39] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: "inputboxstyling mt-2 resize-none",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.terminateObj.terminateComments) = $event)),
                            placeholder: "Reason/Justification for Terminating the Audit",
                            rows: "3"
                          }, null, 512), [
                            [
                              _vModelText,
                              _ctx.terminateObj.terminateComments,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _withDirectives(_createElementVNode("input", {
                            class: "checkbox mr-2",
                            type: "checkbox",
                            id: "retainFindings",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.terminateObj.retainFindings) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, _ctx.terminateObj.retainFindings]
                          ]),
                          _cache[40] || (_cache[40] = _createElementVNode("label", {
                            for: "retainFindings",
                            class: "controllabel"
                          }, "Retain Findings", -1))
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_118, [
                      _createElementVNode("button", {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.TerminatePresentAudit())),
                        class: _normalizeClass(_ctx.terminateObj.terminateComments =='' ? 'btndisabled pointer-events-none': 'btnprimary')
                      }, "Terminate", 2)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 2))
}